<script setup lang="ts">
import { disableAppPageBounces } from '@/utils/jsBridge/jsBridge'
import { inject, nextTick, computed } from 'vue'
import { runEnvironment, openJdApp } from '@/utils/util'
import { useRoute } from 'vue-router'
import { updateNoticeInfo, noticeState, jumpNotice } from './hooks/useNotice'
import { sleep } from '@/hooks/useTools'
import { isJD } from '@/utils/channel'
import { setToastDefaultOptions } from '@jdt-jinke/jdtm'

// 使用useRoute钩子获取当前路由对象
const route = useRoute()

// 从当前路由对象中提取meta信息
const routeMeta = computed(() => route.meta || {})

// 全局修改toast默认配置
setToastDefaultOptions({ duration: 2500 })
setToastDefaultOptions('loading', { forbidClick: true })

// 更新公告信息
updateNoticeInfo()

initOpenJdApp()

async function initOpenJdApp() {
  await sleep(100)
  nextTick(() => {
    console.log('------isJD-----', isJD, !isJD)
    if (!isJD) {
      openJdApp('open_jdapp')
      console.log('------openJdApp-----')
    }
  })
}

// onMounted(() => {
//   console.log("APP onMounted");
//   disableAppPageBounces();
// });
</script>

<template>
  <!-- 全局公告 -->
  <div v-if="routeMeta.notice && noticeState.text" @click="jumpNotice">
    <jdtm-notice-bar
      left-icon="sound"
      type="warning"
      mode="closeable"
      :text="noticeState.text"
    ></jdtm-notice-bar>
  </div>

  <!-- 图片预加载 -->
  <div class="preload-img gift-card-bg"></div>
  <div class="preload-img topup-corner-bg"></div>
  <div class="preload-img gift-card-mask"></div>

  <!-- 页面路由 -->
  <router-view v-slot="{ Component }">
    <keep-alive :include="['Square']">
      <component :is="Component" />
    </keep-alive>
  </router-view>

  <!-- 呼起京东APP -->
  <div v-if="!isJD" id="open_jdapp" @touchmove.prevent></div>
</template>

<style lang="less" scoped>
#open_jdapp,
.upgrade-app {
  position: fixed;
  left: 0rem;
  top: 0rem;
  background: rgba(13, 10, 29, 0);
  width: 100vw;
  height: 100vh;
  z-index: 99999;
}
.upgrade-app {
  z-index: 99998;
}
</style>
